import React, { useEffect, useState } from "react";

import {
    Modal,
    Box,
    IconButton,
    Tooltip,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

const ModalImage = ({
    open,
    onClose,
    imageUrl,
}) => {
    const [zoom, setZoom] = useState(1);

    const isPdf = imageUrl
        ?.toLowerCase()
        .split("?")[0]
        .endsWith(".pdf");

    useEffect(() => {
        if (open) {
            setZoom(1);
        }
    }, [open, imageUrl]);

    const zoomIn = () => {
        setZoom((prev) => Math.min(prev + 0.25, 3));
    };

    const zoomOut = () => {
        setZoom((prev) => Math.max(prev - 0.25, 0.5));
    };

    const resetZoom = () => {
        setZoom(1);
    };


    if (!imageUrl) return null;

    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 2,
            }}
        >
            <Box
                sx={{
                    width: "95vw",
                    height: "92vh",
                    maxWidth: 1400,

                    bgcolor: "#181818",

                    borderRadius: 2,
                    overflow: "hidden",

                    display: "flex",
                    flexDirection: "column",

                    outline: "none",
                }}
            >
                {/* HEADER */}
                <Box
                    sx={{
                        height: 55,
                        px: 1.5,

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",

                        bgcolor: "#222",
                        borderBottom:
                            "1px solid #333",

                        gap: 0.5,
                    }}
                >
                    {!isPdf && (
                        <>
                            <Tooltip title="Diminuir zoom">
                                <IconButton
                                    onClick={zoomOut}
                                    disabled={zoom <= 0.5}
                                    sx={{
                                        color: "#FFF",
                                    }}
                                >
                                    <ZoomOutIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Aumentar zoom">
                                <IconButton
                                    onClick={zoomIn}
                                    disabled={zoom >= 3}
                                    sx={{
                                        color: "#FFF",
                                    }}
                                >
                                    <ZoomInIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Restaurar zoom">
                                <IconButton
                                    onClick={resetZoom}
                                    sx={{
                                        color: "#FFF",
                                    }}
                                >
                                    <RestartAltIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    )}

                    <IconButton
                        onClick={onClose}
                        sx={{
                            color: "#FFF",
                            ml: 0.5,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* DOCUMENTO */}
                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        overflow: "auto",

                        bgcolor: "#111",

                        p: 2,
                    }}
                >
                    {isPdf ? (
                        <Box
                            component="iframe"
                            src={imageUrl}
                            title="Documento PDF"
                            sx={{
                                width: "100%",
                                height: "100%",
                                border: 0,
                                bgcolor: "#FFF",
                            }}
                        />
                    ) : (
                        <Box
                            component="img"
                            src={imageUrl}
                            alt="Documento"
                            sx={{
                                maxWidth: "100%",
                                maxHeight: "100%",

                                objectFit: "contain",

                                transform: `scale(${zoom})`,

                                transition:
                                    "transform 0.2s ease",

                                userSelect: "none",
                            }}
                        />
                    )}
                </Box>
            </Box>
        </Modal>
    );
};

export default ModalImage;